<!-- 营销工具 -->
<template>
  <div class="basicStyle">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="招生表单" name="first">
        <div class="querySearch">
          <div class="searchItem">
            <span>考试类型</span>
            <el-select v-model="queryInfo.app_key" size="small" clearable>
              <el-option
                v-for="item in goodAppTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </div>
          <div class="searchItem">
            <span>时间</span>
            <el-date-picker
              v-model="timeFrame"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              @change="selectData"
              end-placeholder="结束日期"
            >
            </el-date-picker>

            <div style="margin-left: 10px; display: inline-block">
              <el-popover
                placement="bottom-start"
                title=""
                width="200"
                trigger="hover"
                :content="desc"
              >
                <i class="el-icon-question el-icon--right" slot="reference"></i>
              </el-popover>
              <!-- <el-tooltip
              width="200"
                placement="bottom-start"
                effect="light"
                popper-class="tooltip-width"
              >
                <div slot="content" v-html="desc"></div>
                <i class="el-icon-question"></i>
              </el-tooltip> -->
            </div>
          </div>

          <div class="searchItem">
            <!-- <el-button type="primary" size="small" @click="queryTable('search')"
              >搜索</el-button
            >
            <el-button type="warning" size="small" @click="resetQuery"
              >重置</el-button
            > -->
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="queryTable('search')"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="resetQuery"
            ></MyButton>
          </div>
        </div>
        <!-- 用户管理 -->
        <div class="table">
          <el-table :data="tableList" stripe style="width: 100%" border>
            <el-table-column
              prop="table_name"
              label="报表名称"
              align="center"
            />
            <el-table-column
              prop="app_type_name"
              label="考试类别"
              align="center"
            />
            <el-table-column
              v-if="!(queryInfo.start_time && queryInfo.end_time)"
              prop="h5_view_count"
              label="总打开次数"
              align="center"
            />
            <!-- <el-table-column
              prop="reg_user_count"
              label="注册人数"
              align="center"
            /> -->

            <el-table-column
              prop="reg_user_count"
              label="注册人数"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="regUserCount(scope.row)"
                  >{{ scope.row.reg_user_count }}</el-button
                >
              </template>
            </el-table-column>

            <el-table-column
              prop="login_user_count"
              label="登录APP人数"
              align="center"
            />
            <el-table-column
              prop="order_count"
              label="商品订单数"
              align="center"
            />
            <el-table-column prop="pay_money" label="商品金额" align="center" />

            <el-table-column
              prop="avatar"
              label="操作"
              align="center"
              width="220"
            >
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="preview(scope.row)"
                  >预览</el-button
                >
                <el-button
                  class="copy_text"
                  type="text"
                  :data-clipboard-text="scope.row.share_link"
                  plain
                  style="margin-left: 10px"
                  @click="copyLink(scope.row)"
                  >复制链接</el-button
                >
                <el-button type="text" size="mini" @click="savePic(scope.row)"
                  >保存图片</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <!-- <TableComponents :columns="columns" :tableData="tableList">
            <template slot="operation" slot-scope="{ row }">
              <el-button type="text" @click="preview(row)">预览</el-button>
              <el-button
                class="copy_text"
                type="text"
                :data-clipboard-text="row.share_link"
                plain
                style="margin-left: 10px"
                @click="copyLink(row)"
                >复制</el-button
              >

              <el-button type="text" @click="savePic(row)">保存图片</el-button>
            </template>
          </TableComponents> -->
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.page"
            :page-sizes="[10, 30, 50, 80]"
            :page-size="queryInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="queryInfo.total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="seNioRiUpShow" label="宣传物料" name="second">
        <!-- 宣传物料 -->
        <div class="recommendBox">
          <!-- <div>
            <el-select
              v-if="appOptions.length > 1"
              size="small"
              v-model="app_keys"
              clearable
              @change="appKeysChange"
              style="
                vertical-align: middle;
                margin-top: -3px;
                margin-left: 10px;
                width: 150px;
              "
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in appOptions"
                :key="item.app_key"
                :label="item.app_key_name"
                :value="item.app_key"
              >
              </el-option>
            </el-select>
          </div> -->
          <!-- <h1>宣传资源分享</h1> -->
          <div class="recommend">
            <div class="recommendItem">
              <div class="itemTop">
                <div class="itemTopL">
                  <img class="img" src="../../assets/share1.png" alt="" />
                </div>
                <div class="itemTopR">
                  <div class="title">题库课程资源宣传网站</div>
                  <div class="cont">可复制网站链接至微信群或朋友圈</div>
                </div>
              </div>
              <div class="itemBt">
                <el-button type="primary" size="small" @click="lookOver"
                  >查看</el-button
                >
                <el-button type="success" size="small" @click="shareLink"
                  >复制分享链接</el-button
                >
              </div>
            </div>
            <div class="recommendItem">
              <div class="itemTop">
                <div class="itemTopL">
                  <img class="img" src="../../assets/share2.png" alt="" />
                </div>
                <div class="itemTopR">
                  <div class="title">微信宣传图片</div>
                  <div class="cont">可分享图片至微信群或朋友圈</div>
                </div>
              </div>
              <div class="itemBt">
                <el-button type="primary" size="small" @click="lookOver2"
                  >查看</el-button
                >
                <el-button type="success" size="small" @click="downloadImg"
                  >下载宣传图片</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="预览" :visible.sync="dialogVisible" width="415px">
      <div class="top-h1">
        <div v-if="app_product_name" class="text">{{ app_product_name }}</div>
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[0]"
        />
        <img v-if="recruitData.logo" class="logo" :src="recruitData.logo" />
      </div>
      <div class="top-h2">
        <div class="top-h2-box">
          <img v-if="intro_img_list" class="img" :src="intro_img_list[1]" />

          <div class="int1Box">
            <input
              disabled
              placeholder="请输入手机号"
              maxlength="11"
              type="tel"
            />
          </div>
          <div class="int2Box">
            <input
              disabled
              placeholder="请输入验证码"
              maxlength="4"
              type="text"
            />
            <div class="btn">获取短信验证码</div>
          </div>
          <div class="int3Box">
            <img class="img" src="../../assets/img/tobpic10.png" />
          </div>
        </div>
      </div>
      <div v-if="intro_img_list && intro_img_list[2]" class="top-h3">
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[2]"
        />
      </div>
      <div v-if="intro_img_list && intro_img_list[3]" class="top-h3">
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[3]"
        />
      </div>
      <div v-if="recruitData.about" class="top-h4">
        <img v-if="intro_img_list" class="title" :src="intro_img_list[4]" />
        <div class="cont">
          {{ recruitData.about }}
        </div>
      </div>
      <div class="top-h5">
        <img v-if="intro_img_list" class="title" :src="intro_img_list[5]" />
        <div class="cont">
          <div
            v-if="recruitData.name"
            class="contItem1"
            style="padding-bottom: 10px"
          >
            <img class="pic" src="../../assets/img/tobpic7.png" />
            <span class="text">{{ recruitData.name }}</span>
          </div>
          <div
            v-if="recruitData.mobile"
            class="contItem2"
            style="padding-bottom: 10px"
          >
            <div class="itemLeft">
              <img class="pic" src="../../assets/img/tobpic8.png" />
              <span class="text">{{ recruitData.mobile }}</span>
            </div>
            <div class="itemRight" @click="callPhone(recruitData.mobile)">
              拨号
            </div>
          </div>
          <div v-if="recruitData.address" class="contItem1">
            <img class="pic" src="../../assets/img/tobpic9.png" />
            <span class="text">{{ recruitData.address }}</span>
          </div>
        </div>
        <div v-if="recruitData.wechat_code" class="wx-title">
          <img class="pic" src="../../assets/img/tobpic16.png" />
          长按识别二维码添加微信
          <img class="pic" src="../../assets/img/tobpic16.png" />
        </div>
        <div v-if="recruitData.wechat_code" class="wx-img">
          <img class="img" :src="recruitData.wechat_code" />
        </div>
      </div>
      <div class="wx-submit">
        <div class="submit">立即领取</div>
      </div>

      <!-- <div v-for="(item, index) in intro_img_list" :key="index">
        <img class="img" :src="item" alt="" />
      </div> -->
    </el-dialog>

    <el-dialog :visible.sync="imgShow" width="415px">
      <img class="img" :src="group_img" alt="" style="width: 100%" />

      <el-button
        type="success"
        @click="downloadImg"
        style="margin-top: 20px; width: 100%"
        >下载宣传图片</el-button
      >

      <div style="margin-top: 20px; width: 100%; text-align: center">
        下载后可分享至微信群或朋友圈
      </div>

      <!-- <div class="imgTop">
        <div class="imgTopLeft">高职单招考试</div>
        <div class="imgTopRight">机构logo</div>
      </div>
      <div class="imgLabel">
        <span class="imgLabelItem">海量资源</span>
        <span class="imgLabelItem">助力通关</span>
      </div>
      <div class="imgContH1">
        <img class="img" src="../../assets/img/问号.png" alt="" />
      </div>
      <div class="imgContH2">
        <img class="img" src="../../assets/img/问号.png" alt="" />
        <div>
          <div class="imgTopLeft">高职单招考试</div>
          <div class="imgTopLeft">高职单招考试</div>
        </div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import Clipboard from "clipboard";
import financialApi from "@/api/financial.js";
import TableComponents from "@/components/TableComponents.vue";
import goodsApi from "@/api/goods.js";
import { clearObj, copyToClip } from "@/utils/index.js";
import * as Utils from "@/utils";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "RecruitList",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        app_key: "", //考试类型
        start_time: "", //创建开始时间
        end_time: "", //创建结束时间
      },
      columns: [
        //列数据
        { label: "报表名称", prop: "table_name" },
        { label: "考试类别", prop: "app_type_name" },
        { label: "总打开次数", prop: "h5_view_count" },
        { label: "注册人数", prop: "reg_user_count" },
        { label: "登录APP人数", prop: "login_user_count" },
        { label: "商品订单数", prop: "order_count" },
        { label: "商品金额", prop: "pay_money" },
        { label: "操作", prop: "operation", width: 300 },
      ],
      tableList: [],

      dialogVisible: false,
      // 读取文件
      fileData: "",
      timeFrame: [],
      activeName: "first",
      goodAppTypeOptions: [
        { key: "adultscollege", value: "成考" },
        { key: "senioriup", value: "高职单招" },
      ],
      desc: "提示：可通过分享二维码及链接的方式邀请学员填写：目的在于获取学员个人信息，并与学员管理打通，建立起学员资料表，形成以学员为中心的销售线索。",
      intro_img_list: [],
      shareLinkData: "",
      imgShow: false,
      group_img: "",
      group_status: "",
      contacts: "",
      contacts_moblie: "",
      quickresponse: "",
      group_id: "",
      app_keys: "",
      appOptions: [],
      list: [
        {
          label: "student_total",
          name: "累计新增学员",
          value: 0,
          path: "/studentManage",
        },
        {
          label: "order_total",
          name: "累计新增订单",
          value: 0,
          path: "/orderList",
        },
        {
          label: "sale",
          name: "累计销售额",
          value: "¥0",
          path: "/orderList",
        },
        {
          label: "fee",
          name: "账户余额",
          value: "¥0",
          path: "/financialManage",
        },
      ],
      is_show_marketing: 0,
      recruitData: {},
      seNioRiUpShow: false,
      app_product_name: "",
    };
  },
  created() {
    this.getTobOpenExams();
    this.is_show_marketing = localStorage.getItem("is_show_marketing");
    console.log("this.is_show_marketing", this.is_show_marketing);
    if (this.is_show_marketing == 1) {
      this.queryTable();
      this.activeName = "first";
    } else {
      this.activeName = "second";
    }

    this.homeList();
  },
  computed: {},
  watch: {},
  methods: {
    regUserCount(e) {
      console.log("regUserCount", e);
      this.$router.push({
        path: "/studentManage",
        query: { add_type: true, app_type: e.app_type },
      });
    },
    async getTobOpenExams() {
      this.seNioRiUpShow = false;
      const res = await goodsApi.getTobOpenExams(this.queryInfo);
      if (res.code == 200) {
        res.data.exam_list.forEach((item) => {
          console.log("senioriup", item.key, item.key == "senioriup");
          if (item.key == "senioriup") {
            this.seNioRiUpShow = true;
          }
        });
      }
    },
    appKeysChange(e) {
      console.log("appKeysChange", e);
      this.app_keys = e;
      this.homeList();
    },
    async homeList() {
      const res = await commonApi.homeData({ app_keys: this.app_keys });
      if (res.code == 200) {
        let _obj = res.data;
        let _arr = Object.keys(_obj);
        this.list.forEach((item, index) => {
          _arr.forEach((_item, _index) => {
            if (item.label === _item) {
              //  item.label);
              this.list[index].value = _obj[_item];
            }
          });
        });
        console.log("homeList", res.data);
        this.shareLinkData = res.data.web_domain;
        this.group_img = res.data.group_img;
        this.group_status = res.data.group_status;
        this.group_id = res.data.group_id;

        this.appOptions = res.data.menu;
      } else {
        this.$message.error(res.message);
      }
    },

    downloadImg() {
      var query = { group_id: this.group_id };
      const newUrl = process.env.VUE_APP_SERVE + "/api/v1/tob/downGroupImg";
      const url = Utils.getGetUrl(newUrl, "get", query);
      console.log("downloadImg", url);
      window.open(url, "_blank");
    },
    lookOver2() {
      // 查看
      // window.open(this.shareLinkData, "_blank");
      this.imgShow = true;
    },
    lookOver() {
      // 查看
      // window.location.href = this.shareLinkData;
      window.open(this.shareLinkData, "_blank");
    },
    shareLink() {
      // 复制分享链接
      this.$message.success("复制成功");
      copyToClip(`${this.shareLinkData}`);
    },

    async savePic(e) {
      console.log("savePic", e.share_bg_img);
      const res = await financialApi.tobShareImg({
        share_link: e.share_link,
        share_bg_img: e.share_bg_img,
      });
      if (res.code == 200) {
        this.downloadByBlob(res.data.share_img_url, e.table_name + "H5");
      }
    },
    downloadByBlob(url, name) {
      console.log("downloadByBlob", url, name);
      const downloadRes = async (url, name) => {
        // console.log("run downloadRes",objectUrl,name);
        let response = await fetch(url);
        // 内容转变成blob地址
        let blob = await response.blob();
        // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        //地址
        a.href = objectUrl;
        //修改文件名
        a.download = name;
        // 触发点击
        document.body.appendChild(a);
        a.click();
        //移除
        setTimeout(() => document.body.removeChild(a), 1000);
      };
      downloadRes(url, name);
    },
    preview(e) {
      this.dialogVisible = true;
      this.app_product_name = e.app_type_name;
      this.intro_img_list = e.intro_img_list;
    },
    copyLink() {
      const clipboard = new Clipboard(".copy_text");
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy(); // 释放内存
      });
    },
    // 列表数据
    async queryTable() {
      const res = await financialApi.recruitData(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.list;
        this.recruitData = res.data.group_info;
        // this.tableList.forEach((item, index) => {
        //   this.tableList[index].finType = item.type == 1 ? "支出" : "收入";
        //   let _noti = "";
        //   switch (item.transaction) {
        //     case 1:
        //       _noti = "视频课程";
        //       break;
        //     case 2:
        //       _noti = "题库会员";
        //       break;
        //     case 3:
        //       _noti = "学籍卡";
        //       break;
        //     case 4:
        //       _noti = "vip学员";
        //       break;
        //     case 5:
        //       _noti = "退款";
        //       break;
        //     case 6:
        //       _noti = "充值";
        //       break;
        //     case 7:
        //       _noti = "平台号码导入";
        //       break;
        //     case 8:
        //       _noti = "平台号码导入通话";
        //       break;
        //     case 9:
        //       _noti = "自有号码通话";
        //       break;
        //     case 10:
        //       _noti = "套餐";
        //       break;
        //   }
        //   this.tableList[index].finTransaction = _noti;
        //   //  item.qorder);
        //   if (item.qorder) {
        //     this.tableList[index].order_no =
        //       this.tableList[index].qorder.order_no;
        //     this.tableList[index].username =
        //       this.tableList[index].qorder.user_no;
        //   }
        // });
      } else {
        this.$message.error(res.message);
      }
    },

    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },

    // 选择日期
    selectData(e) {
      //  e);
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        app_key: "",
        start_time: "",
        end_time: "",
      };
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    // display: inline-block;
    // margin: 0 5px;
    // cursor: pointer;
    // color: rgb(87, 87, 239);
  }
  .el-button.is-plain:hover {
    // border: none;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
.tooltip-width {
  max-width: 200px;
}

/deep/ .recommendBox {
  display: block;
  margin-top: 20px;
  .recommend {
    margin-top: 20px;
    display: flex;
    .recommendItem {
      margin: 0 5px;
      padding: 15px;
      text-align: center;
      border: 1px solid #ddd;
      width: 360px;
      .itemTop {
        display: flex;
        justify-content: space-between;

        .itemTopL {
          width: 20%;
          // height: 40px;
          // background-color: #ddd;
          .img {
            width: 100%;
            // height: 40px;
          }
        }
        .itemTopR {
          width: 75%;
          .title {
            font-size: 15px;
            color: #333;
            font-weight: bold;
            text-align: left;
            line-height: 120%;
          }
          .cont {
            font-size: 14px;
            color: #434446;
            text-align: left;
            margin-top: 5px;
            .contItem {
              margin-right: 10px;
            }
          }
        }
      }
      .itemBt {
        justify-content: flex-end;
        display: flex;
        margin-top: 10px;
      }
    }
  }
}

.top-h1 {
  display: block;
  position: relative;
  .text {
    position: absolute;
    left: 0;
    top: 16px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-left: 25px;
  }
  .img {
    display: block;
    width: 100%;
  }
  .logo {
    display: block;
    width: 120px;
    height: 54px;
    position: absolute;
    right: 0;
    top: 13px;
    padding: 5px 3px 5px 12px;
    background-color: #fff;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}

.top-h2 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -4px 20px 0px rgba(172, 159, 255, 0.3);
  margin-top: -20px;
  background-color: #fff;
  z-index: 1;
  position: relative;
  .top-h2-box {
    padding: 25px 25px 0 25px;
    .img {
      width: 135px;
      display: block;
      margin: 0 auto;
      padding-bottom: 20px;
    }
    .int1Box {
      padding-bottom: 20px;
      input,
      .input {
        width: calc(100% - 48px);
        height: 46px;
        padding: 0 24px 0 24px;
        background: #f7f8fb;
        border-radius: 280px;
        border: none;
        opacity: 1;
      }
    }
    .int2Box {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 4px;
      overflow: hidden;
      background: #f7f8fb;
      padding: 0 24px;
      height: 46px;
      border-radius: 280px;
      margin-bottom: 22px;
      input,
      .input {
        position: relative;
        width: 60%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 9px;
        font-size: 13px;
        line-height: 100%;
        background: #f7f8fb;
        border: none;
        &.invalid,
        &::-webkit-input-placeholder {
          color: #999fb5;
        }
        &.alignRight {
          text-align: right;
        }
        .arrows {
          position: absolute;
          top: 0;
          right: 10px;
        }
      }
      .shape,
      .btn,
      .mask {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        line-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .shape {
        right: 10px;
        color: #999fb5;
      }
      .btn {
        right: 24px;
        width: 100px;
        font-size: 13px;
        font-family: "PingFang SC-常规体", "PingFang SC";
        color: #5659dd;
        &.invalid {
          color: #999fb5;
          width: auto;
          padding: 0 10px;
        }
      }
      .mask {
        width: 100%;
        opacity: 0;
        z-index: 9;
      }
      & + .inp {
        margin-left: 10px;
      }
    }
    .int3Box {
      display: block;
      .img {
        display: block;
        width: 100%;
      }
    }
  }
}

.top-h3 {
  display: block;
  .img {
    display: block;
    width: 100%;
  }
}
.top-h4 {
  padding-top: 28px;
  background: url(../../assets/img/tobpic13.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
  }
  .cont {
    padding: 32px 29px 42px 29px;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #465069;
    line-height: 28px;
    // min-height: 200px;
  }
}

.top-h5 {
  padding-top: 28px;
  padding-bottom: 36px;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 26px;
  background: url(../../assets/img/tobpic15.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
    padding-bottom: 36px;
  }
  .cont {
    padding: 16px 19px;
    background-color: #fff;
    box-shadow: 0px 5px 18px 0px rgba(234, 218, 255, 0.6554);
    border-radius: 19px;
    .contItem1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .pic {
        display: inline-block;
        width: 17px;
        height: 17px;
        vertical-align: middle;
        margin-right: 10px;
      }
      .text {
        display: inline-block;
        font-size: 15px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #465069;
        line-height: 17px;
        width: 80%;
        vertical-align: middle;
      }
    }
    .contItem2 {
      display: flex;
      justify-content: space-between;
      .itemLeft {
        width: 70%;
        .pic {
          display: inline-block;
          width: 17px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .text {
          display: inline-block;
          font-size: 15px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #465069;
          line-height: 15px;
          width: 60%;
          vertical-align: middle;
        }
      }

      .itemRight {
        background: #ff7f3b;
        box-shadow: 0px 0px 12px 0px rgba(91, 37, 240, 0.1);
        border-radius: 50px;
        font-size: 13px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #ffffff;
        line-height: 100%;
        padding: 5px 11px;
      }
    }
  }

  .wx-title {
    font-size: 17px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: 400;
    color: #ff7c39;
    line-height: 100%;
    text-align: center;
    padding: 26px 0 20px 0;
    .pic {
      display: inline-block;
      width: 8px;
      vertical-align: middle;
      margin: 0 4px;
    }
  }
  .wx-img {
    width: 163px;
    height: 163px;
    margin: 0 auto;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}

.wx-submit {
  padding: 12px 16px 10px 16px;
  background-color: #fff;
  margin-top: -12px;
  .submit {
    width: 100%;
    height: 48px;
    display: block;
    text-align: center;
    line-height: 48px;
    background: linear-gradient(270deg, #ff7c39 0%, #ffb15c 100%);
    border-radius: 26px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
  }
}
</style>
